import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {GenericDocARAPContainerModel} from '../../../../../../models/aggregates/generic_doc';
import { ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class ARAPLoginEntityService extends BaseApiTemplateService<GenericDocARAPContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = `${Core2Config.DOMAIN_URL}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}gen-doc/arap-contras/login-entity-ep`
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}gen-doc/arap-contras/login-entity-ep`;
    this.httpClient = http;
  }

  getGenDocHdrGuidsByGenDocArapPgwQueryDto(genDocArapPgwQueryDto: any, entityHdrGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<string[]>> {
    if (visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_PREFIX}arap-contras`;
    }
    const url = this.apiUrl + '/pgw-merchant/login-entity-ep/query?entityHdrGuid=' + entityHdrGuid;
    return this.httpClient.post<BasicApiResponseModel<string[]>>(url, genDocArapPgwQueryDto, this.getHttpHeader(visa));
  }
}
